import React, { InputHTMLAttributes } from 'react'

import * as S from './styles'

interface IInputRadioProps extends InputHTMLAttributes<HTMLInputElement> {
    name: string
    label?: string
    classNameContainer?: string
}

const InputRadio: React.FC<IInputRadioProps> = ({
    name,
    label = '',
    classNameContainer = '',
    ...rest
}) => {
    return (
        <S.Container
            className={`input-radio${
                classNameContainer ? ` ${classNameContainer}` : ''
            }`}
        >
            <input {...rest} type="radio" />
            {label && <label htmlFor={name}>{label}</label>}
        </S.Container>
    )
}

export default InputRadio
